import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
export class SquarzHeuristic extends PlayerMetricHeuristic {
    getMetrics(node) {
        return node.gameState.getScores().toTable();
    }
}
